import angular from 'angular';
import reportsDataService from '../data/reports.data.service';
import ISharedModelService from './ISharedModel.service';

let _reportsDataService;

export class reportsSharedModelService extends ISharedModelService {
  constructor(
    reportsDataService, // eslint-disable-line no-shadow
  ) {
    super('reports');
    _reportsDataService = reportsDataService;
    console.log('app.services.reportsSharedModelService created');
  }

  getReportFamilies(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.reportFamilies) {
      this.cache.reports.reportFamilies = _reportsDataService
        .getReportFamilies()
        .then(response => response.data.result);
    }
    return this.cache.reports.reportFamilies;
  }

  getReportGroups(applicationId, forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.reportGroups) {
      this.cache.reports.reportGroups = _reportsDataService
        .getReportGroups(applicationId)
        .then(response => response.data.result);
    }
    return this.cache.reports.reportGroups;
  }

  getScheduledReportSummary(applicationId, forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.scheduledReportSummary) {
      this.cache.reports.scheduledReportSummary = _reportsDataService
        .getScheduledReportSummary(applicationId)
        .then(response => response.data.result);
    }
    return this.cache.reports.scheduledReportSummary;
  }

  getArchivedReportInstanceSummary(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.archivedReportInstanceSummary) {
      this.cache.reports.archivedReportInstanceSummary = _reportsDataService
        .getArchivedReportInstanceSummary()
        .then(response => response.data.result);
    }
    return this.cache.reports.archivedReportInstanceSummary;
  }

  getArchivedReportInstances(uniqueId, forceRefresh = false) {
    const key = uniqueId.toString();

    if (forceRefresh || !this.cache.reports.archivedReportInstances[key]) {
      this.cache.reports.archivedReportInstances[key] = _reportsDataService
        .getArchivedReportInstances(uniqueId)
        .then(response => response.data.result);
    }
    return this.cache.reports.archivedReportInstances[key];
  }

  getMyReportInstanceSummary(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.myReportInstanceSummary) {
      this.cache.reports.myReportInstanceSummary = _reportsDataService
        .getMyReportInstanceSummary()
        .then(response => response.data.result);
    }
    return this.cache.reports.myReportInstanceSummary;
  }


  getMyReportInstances(uniqueId, forceRefresh = false) {
    const key = uniqueId.toString();

    if (forceRefresh || !this.cache.reports.myReportInstances[key]) {
      this.cache.reports.myReportInstances[key] = _reportsDataService
        .getMyReportInstances(uniqueId)
        .then(response => response.data.result);
    }
    return this.cache.reports.myReportInstances[key];
  }


  getCustomerReportInstanceSummary(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.customerReportInstanceSummary) {
      this.cache.reports.customerReportInstanceSummary = _reportsDataService
        .getCustomerReportInstanceSummary()
        .then(response => response.data.result);
    }
    return this.cache.reports.customerReportInstanceSummary;
  }

  getCustomerReportInstances(uniqueId, forceRefresh = false) {
    const key = uniqueId.toString();

    if (forceRefresh || !this.cache.reports.customerReportInstances[key]) {
      this.cache.reports.customerReportInstances[key] = _reportsDataService
        .getCustomerReportInstancesByUId(uniqueId)
        .then(response => response.data.result);
    }
    return this.cache.reports.customerReportInstances[key];
  }

  getOldPackagedReports(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.packagedReports) {
      this.cache.reports.packagedReports = _reportsDataService
        .getOldPackagedReports()
        .then(response => response.data.result);
    }
    return this.cache.reports.packagedReports;
  }

  getNewPackagedReports(forceRefresh = false) {
    if (forceRefresh || !this.cache.reports.packagedReports) {
      this.cache.reports.packagedReports = _reportsDataService
        .getNewPackagedReports()
        .then(response => response.data.result);
    }
    return this.cache.reports.packagedReports;
  }

  publishReportInstance(reportId, reportInstanceId, familyId) {
    this._invalidatePublishedReportsCache(reportId);
    return _reportsDataService
      .publishReportInstance(reportInstanceId, familyId)
      .then(response => response.status === 200);
  }

  unpublishReportInstance(reportId, reportInstanceId, destinationId) {
    this._invalidatePublishedReportsCache(reportId);
    return _reportsDataService
      .unpublishReportInstance(reportInstanceId, destinationId)
      .then(response => response.status === 200);
  }

  _invalidatePublishedReportsCache(reportId) {
    this.cache.invalidate('reports.customerReportInstances', reportId);
    this.cache.invalidate('reports.customerReportInstanceSummary');
    this.cache.invalidate('reports.myReportInstances', reportId);
    this.cache.invalidate('reports.myReportInstanceSummary');
    this.cache.invalidate('reports.archivedReportInstances', reportId);
    this.cache.invalidate('reports.archivedReportInstanceSummary');
  }
}

reportsSharedModelService.$inject = ['reportsDataService'];

export default angular
  .module('app.services.reportsSharedModelService', [reportsDataService])
  .service('reportsSharedModelService', reportsSharedModelService).name;
